
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { DeviceControllerOutput } from "@/store/site-monitor-cameras/types";
import { EventDetails } from "@/store/site-monitor/types";
import ControlDeviceItem from "./ControlDeviceItem.vue";

const SMCameras = namespace("siteMonitorCameras");
const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		ControlDeviceItem
	}
})
export default class ControlDevicesList extends Vue {
	@SiteMonitor.Getter("getEventDetails") getEventDetails: EventDetails;

	@SMCameras.Action fetchAreaOutputs: (params: { groupID: number, pageNumber: number, paginated: boolean }) => Promise<void>;
	@SMCameras.State("areaOutputCount") public areaOutputCount: number;

	@Prop() outputs!: DeviceControllerOutput[];
	@Prop() title!: string;
	@Prop({ default: false, type: Boolean }) isAreaOutputs!: boolean;

	private openOutputs: boolean = false;
	private pageNumber: number = 1;

	private get showLoadMoreButton(): boolean {
		return this.isAreaOutputs && this.outputs.length > 0 && this.outputs.length < this.areaOutputCount;
	}

	private showMoreOutputs(): void {
		if (!this.isAreaOutputs) {
			return;
		}

		this.pageNumber++;
		this.fetchAreaOutputs({ groupID: this.getEventDetails.groupID, pageNumber: this.pageNumber, paginated: true });
	}

	public collapseOutputSections(): void {
		this.openOutputs = false;
	}
}
